export type InventoryItemType = 'Goods' | 'Service'

export interface InventoryItemRow {
  id: string
  code: string
  name: string
  description: string
  type: InventoryItemType
  category: string
  subCategory: string
}

export const INITIAL_MOCK_ITEMS: InventoryItemRow[] = [
  {
    id: '1',
    code: '001',
    name: 'Nokia1210',
    description: 'Rent',
    type: 'Goods',
    category: 'Service',
    subCategory: 'abc',
  },
  {
    id: '2',
    code: '2',
    name: 'Sample',
    description: '—',
    type: 'Service',
    category: 'test',
    subCategory: '—',
  },
]
